<div class="modal fade video-modal" [id]="'imageModal'+index" tabindex="-1" role="dialog" aria-labelledby="videoModalTitle"
aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <main class="main-body modal-content clearfix">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <p><img class="w-100 h-50" [src]="img" alt=""></p>
  </main> <!-- /.main-body -->
</div>
</div>

